import React from 'react';
import ORB1InspectorView from '../../../../../marpol/orb1/history/ORB1InspectorView';
import ORB4InspectorView from '../../../../../marpol/orb2/history/ORB4InspectorView';
import CRBInspectorView from 'components/app/marpol/crb/history/CRBInspectorView';
import GRB1InspectorView from 'components/app/marpol/garbage-record/history/GRB1InspectorView';
import GRB2InspectorView from 'components/app/marpol/grb2/history/GRB2InspectorView';
import BFL1InspectorView from 'components/app/marpol/bfl-1/history/BFL1InspectorView';
import Biofouling2InspectorView from 'components/app/marpol/bfl-2/history/Biofouling2InspectorView';
import Annex6InspectorView from 'components/app/marpol/annex6/history/Annex6InspectorView';
import BallastInspectorView from 'components/app/marpol/ballast/history/BallastInspectorView';
import BallastTankOperationsInspectorView from 'components/app/marpol/ballast-tank-operations/BallastTankOperationsInspectorView';
import Annex6V2InspectorView from 'components/app/marpol/annex6-v2/history/Annex6V2InspectorView';

const MarpolModule = (props: { bookId: string; showCoverPages: boolean, vesselId: string }) => {
    const { bookId, showCoverPages, vesselId } = props;

    switch (bookId) {
        case 'ORB1':
            return <ORB1InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'ORB4':
            // NOTE: ORB 2 is referred as ORB 4 in the code
            return <ORB4InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
        case 'CRB':
            return <CRBInspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
        case 'GRB1':
            return <GRB1InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'GRB2':
			return <GRB2InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'BFL1':
			return <BFL1InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'BFL2':
			return <Biofouling2InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
        case 'ANNEX6':
            return <Annex6InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'ANNEX6V2':
			return <Annex6V2InspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'BALLAST':
			return <BallastInspectorView vesselId={vesselId} showCoverPages={showCoverPages} />;
		case 'BALLAST_TANK_OPERATIONS':
			return <BallastTankOperationsInspectorView vesselId={vesselId} showCoverPages={showCoverPages}/>
        default:
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    Requested marpol book is not available!
                </div>
            );
    }
};

export default MarpolModule;
